(function () {
  var KEY = 'wi_zichtzending';
  var MAX = 6;

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }

  function save(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wi:zicht:update', { detail: { count: items.length } }));
  }

  function add(product) {
    var items = get();
    if (items.some(function (i) { return i.id === product.id; })) return false;
    if (items.length >= MAX) return false;
    items.push(product);
    save(items);
    return true;
  }

  function remove(id) {
    save(get().filter(function (i) { return i.id !== id; }));
  }

  function has(id) {
    return get().some(function (i) { return i.id === id; });
  }

  function updateCounters() {
    var count = get().length;
    document.querySelectorAll('[data-wi-zicht-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.style.opacity = count > 0 ? '1' : '0';
    });
  }

  /* ── Slider ── */
  var _offset = 0;

  function sliderStep() {
    var card = document.querySelector('#WI_zicht_products .WI_zicht_card');
    return card ? card.offsetWidth + 20 : 260;
  }

  function sliderMax() {
    var vp = document.querySelector('.WI_zicht_slider_viewport');
    var grid = document.getElementById('WI_zicht_products');
    if (!vp || !grid) return 0;
    var cards = Array.from(grid.querySelectorAll('.WI_zicht_card'));
    if (!cards.length) return 0;
    var total = cards.reduce(function (s, c) { return s + c.offsetWidth + 20; }, -20);
    return Math.max(0, total - vp.clientWidth);
  }

  function applySlider() {
    var grid = document.getElementById('WI_zicht_products');
    if (!grid) return;
    var max = sliderMax();
    _offset = Math.max(0, Math.min(_offset, max));
    grid.style.transform = 'translateX(-' + _offset + 'px)';
    var prev = document.getElementById('WI_zicht_prev');
    var next = document.getElementById('WI_zicht_next');
    if (prev) prev.disabled = _offset <= 0;
    if (next) next.disabled = _offset >= max;
  }

  /* ── Page render ── */
  function renderPage() {
    var grid = document.getElementById('WI_zicht_products');
    if (!grid) return;
    _offset = 0;
    var items = get();
    if (items.length === 0) {
      grid.innerHTML = '<p class="WI_zicht_empty">Je hebt nog geen tapijten toegevoegd aan je zichtzending aanvraag.<br>Ga naar een tapijt en klik op <strong>Zichtzending aanvragen</strong>.</p>';
      applySlider();
      return;
    }
    grid.innerHTML = items.map(function (item) {
      return '<div class="WI_zicht_card">' +
        '<button class="WI_zicht_card_remove" data-wi-zicht-remove="' + item.id + '" aria-label="Verwijder">&#x2715;</button>' +
        '<a href="' + item.url + '" class="WI_zicht_card_link">' +
        '<div class="WI_zicht_card_img"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></div>' +
        '<p class="WI_zicht_card_title">' + item.title + '</p>' +
        '</a></div>';
    }).join('');
    setTimeout(applySlider, 0);
  }

  function initAddButtons() {
    document.querySelectorAll('[data-wi-zicht-add]').forEach(function (btn) {
      var id = parseInt(btn.dataset.productId, 10);
      var txtEl = btn.querySelector('[data-wi-zicht-txt]');
      if (has(id) && txtEl) {
        txtEl.textContent = 'Bekijk zichtzending →';
        btn.dataset.wiZichtAdded = '1';
      }
    });
  }

  /* ── Events ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#WI_zicht_prev')) {
      _offset -= sliderStep();
      applySlider();
      return;
    }
    if (e.target.closest('#WI_zicht_next')) {
      _offset += sliderStep();
      applySlider();
      return;
    }

    var addBtn = e.target.closest('[data-wi-zicht-add]');
    if (addBtn) {
      e.preventDefault();
      var id = parseInt(addBtn.dataset.productId, 10);
      var txtEl = addBtn.querySelector('[data-wi-zicht-txt]');
      if (addBtn.dataset.wiZichtAdded === '1' || has(id)) {
        window.location.href = '/pages/zichtzending';
        return;
      }
      if (get().length >= MAX) {
        if (confirm('Je hebt al ' + MAX + ' tapijten toegevoegd. Wil je de zichtzending bekijken?')) {
          window.location.href = '/pages/zichtzending';
        }
        return;
      }
      add({ id: id, handle: addBtn.dataset.handle, title: addBtn.dataset.title, image: addBtn.dataset.image, url: addBtn.dataset.url });
      updateCounters();
      if (txtEl) {
        txtEl.textContent = 'Toegevoegd ✓';
        addBtn.classList.add('WI_zicht_btn_done');
      }
      setTimeout(function () {
        if (txtEl) txtEl.textContent = 'Bekijk zichtzending →';
        addBtn.dataset.wiZichtAdded = '1';
        addBtn.classList.remove('WI_zicht_btn_done');
      }, 1500);
    }

    var removeBtn = e.target.closest('[data-wi-zicht-remove]');
    if (removeBtn) {
      remove(parseInt(removeBtn.dataset.wiZichtRemove, 10));
      updateCounters();
      renderPage();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#WI_zicht_form');
    if (!form) return;
    var listField = document.getElementById('WI_zicht_items_field');
    var items = get();
    if (listField && items.length > 0) {
      listField.value = items.map(function (i) {
        return '• ' + i.title + '\n  ' + (window.location.origin + i.url);
      }).join('\n\n');
    }
    save([]);
    updateCounters();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCounters();
    renderPage();
    initAddButtons();
  });

  document.addEventListener('wi:zicht:update', updateCounters);
  window.addEventListener('resize', applySlider);
})();
